import { MrbApplicationMainSectionStore } from "mrb/core/stores";
import { moduleBuilder } from "mrb/core/infrastructure";
import { MrbModalParams } from "mrb/common/models";
import { find } from "lodash";
import { producerTypes } from "common/constants";
import { localizationService } from "common/localization";

const LOADIO_MENU_TITLE = "ADMINISTRATION.MENU.LOADIO";
const LOADIO_DASHBOARD_MENU_TITLE = "ADMINISTRATION.MENU.LOADIO_DASHBOARD";

class NakiRadioApplicationSectionStore extends MrbApplicationMainSectionStore {
    constructor(rootStore) {
        super(rootStore);
        this.trialActivatedModal = new MrbModalParams(null, null);
    }

    async initialize() {
        if (this.rootStore.authenticationStore.isAuthenticated && !this.rootStore.userStore.isAdministrator) {
            await Promise.all([
                this.rootStore.userDeviceStore.initialize(),
                //this.rootStore.premiumSubscriptionStore.refreshUserPremiumSubscription(),
            ]);

            if (
                this.rootStore.premiumSubscriptionStore.premiumTrialSubscriptionExist &&
                this.rootStore.userDeviceStore.deviceCount === 0
            ) {
                this.trialActivatedModal.open();
            }
        }
        if (!this.isInitialized) {
            this.rootStore.authenticationStore.resetSignInRedirect();
            this.buildMenu();
            this.setIsInitialized(true);
        }
    }

    buildMenu() {
        if (this.rootStore.userStore.isAdministrator) {
            this._buildAdministratorMenu();
        } else if (this.rootStore.userStore.isLoadio) {
            this._buildLoadioOnlyAdminMenu();
        } else {
            this._buildApplicationMenu(["application"]);
        }

        // setMenu() replaces every MenuItem with a fresh instance, but the menu store only marks
        // one active from a reaction on the router state. Rebuilding without navigating - which is
        // what switching the selected device does - therefore leaves no item marked active until
        // the next navigation, so the current section is re-marked here.
        const { menuStore, routerStore } = this.rootStore;
        if (routerStore.routerState) {
            menuStore.syncMenuRoute(routerStore.routerState);
        }
    }

    _buildAdministratorMenu() {
        const menu = moduleBuilder.buildMenus(
            this.rootStore.configuration.menus,
            { rootStore: this.rootStore },
            ["administration"]
        );

        // For admins, fold the "Loadio Dashboard" submenus into "Loadio" so they
        // see a single combined menu. Loadio-role users still get the dashboard
        // as its own top-level menu (see _buildLoadioOnlyAdminMenu).
        const loadioMenu = find(menu, (item) => item.title === LOADIO_MENU_TITLE);
        const loadioDashboardMenu = find(menu, (item) => item.title === LOADIO_DASHBOARD_MENU_TITLE);
        if (loadioMenu && loadioDashboardMenu && loadioDashboardMenu.subMenu) {
            // Dashboard items use orders 1..N just like the Loadio submenus, so bump
            // them past the existing max to keep them at the bottom of the merged list.
            const existing = loadioMenu.subMenu || [];
            const maxOrder = existing.reduce((m, i) => Math.max(m, i.order || 0), 0);
            const appended = loadioDashboardMenu.subMenu.map((item, idx) => ({
                ...item,
                order: maxOrder + idx + 1,
            }));
            loadioMenu.subMenu = [...existing, ...appended];
        }
        const merged = menu.filter((item) => item.title !== LOADIO_DASHBOARD_MENU_TITLE);

        this.rootStore.menuStore.setMenu(merged);
    }

    _buildLoadioOnlyAdminMenu() {
        const menu = moduleBuilder.buildMenus(
            this.rootStore.configuration.menus,
            { rootStore: this.rootStore },
            ["administration"]
        );

        const loadioDashboardMenu = find(menu, (item) => item.title === LOADIO_DASHBOARD_MENU_TITLE);
        this.rootStore.menuStore.setMenu(loadioDashboardMenu ? [loadioDashboardMenu] : []);
    }

    _buildApplicationMenu(modules) {
        var menu = moduleBuilder.buildMenus(this.rootStore.configuration.menus, { rootStore: this.rootStore }, modules);

        var producerMenu = find(menu, (item) => item.route === "master.application.producer.preview.dashboard");
        var producerVerification = producerMenu && this.rootStore.userStore.isProducer;
        if (producerVerification && this.rootStore.userStore.producerType?.slug === producerTypes.artistSlug) {
            producerMenu.title = localizationService.t("APPLICATION.PRODUCER.MENU.ARTIST_TITLE");
        } else if (
            producerVerification &&
            this.rootStore.userStore.producerType?.slug === producerTypes.podcasterSlug
        ) {
            producerMenu.title = localizationService.t("APPLICATION.PRODUCER.MENU.PODCASTER_TITLE");
        }

        this.rootStore.menuStore.setMenu(menu);
    }
}

export default NakiRadioApplicationSectionStore;
